import { render, staticRenderFns } from "./PageMyJourneyMeasumentChartBoxSkeleton.vue?vue&type=template&id=608415e1&scoped=true"
import script from "./PageMyJourneyMeasumentChartBoxSkeleton.vue?vue&type=script&lang=js"
export * from "./PageMyJourneyMeasumentChartBoxSkeleton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "608415e1",
  null
  
)

export default component.exports